<template>
  <section id="portfolio">
    <b-container class="text-center">
      <b-row>
        <b-col>
          <h1>Portfolio</h1>
          <hr />
        </b-col>
      </b-row>
      <div class="gridCard" v-if="!GlobalData.portfolio">
        <portfolioCardClassic
          :startup="startup"
          v-for="(startup, index) in Portfolio"
          :key="index"
        />
      </div>
      <br /><br />
      <swiper :options="swiperOption" v-if="GlobalData.portfolio">
        <swiper-slide v-for="(startup, index) in Portfolio" :key="index">
          <portfolioCard :startup="startup" />
        </swiper-slide>

        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </b-container>
  </section>
</template>

<script>
import PortfolioJSON from "../assets/portfolio.json";
import portfolioCard from "@/components/PortfolioCard.vue";
import portfolioCardClassic from "@/components/PortfolioCardClassic.vue";
import { db } from "../main";
export default {
  data() {
    return {
      swiperPortfolio: PortfolioJSON.switchPortfolio,
      Portfolio: PortfolioJSON.portfolio,
      GlobalData: {},
      swiperOption: {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        coverflowEffect: {
          rotate: 50,
          stretch: -50,
          depth: 100,
          modifier: 1,
          slideShadows: true
        },
        pagination: {
          el: ".swiper-pagination"
        }
      }
    };
  },
  components: {
    portfolioCard,
    portfolioCardClassic
  },
  mounted() {
    const docRef = db.collection("GlobalData").doc("Data");
    docRef.get().then(doc => {
      this.GlobalData = doc.data();
    });
  }
};
</script>

<style>
#portfolio {
  background-color: #f6f6f6;
  padding: 100px 0;
}
#portfolio .swiper-slide {
  background-position: center;
  background-size: cover;
  width: 300px;
  height: 300px;
}
.swiper-pagination-bullet {
  color: red;
}

#portfolio .gridCard {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(175px, 1fr));
  grid-template-rows: 1fr;
  grid-gap: 20px;
  padding: 0 75px;
  justify-items: center;
}

#portfolio hr {
  width: 20rem;
  height: 0.05rem;
  margin: 2rem auto 2rem;
  margin-bottom: 3rem;
}

@media (max-width: 768px) {
  #portfolio .gridCard {
    padding: 0px 0px;
  }
}
</style>